import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import { Gift } from 'lucide-react';
import { course_header_price_free } from '@paraglide/messages';
import { COURSE_DETAIL_TEST_IDS } from '@edusense/shared-constants';
const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const FreeBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.75rem;
  background-color: #10b981;
  color: white;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
`;
const PriceAmount = styled.span`
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
`;
const OriginalPrice = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
  text-decoration: line-through;
  margin-right: 0.5rem;
`;
const DiscountBadge = styled.span`
  background-color: #ef4444;
  color: white;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  margin-left: 0.5rem;
`;
export const CourseHeaderPrice = ({ price, isFree = false })=>{
    if (isFree) {
        return /*#__PURE__*/ _jsx(PriceWrapper, {
            "data-testid": COURSE_DETAIL_TEST_IDS.PRICE_SECTION,
            children: /*#__PURE__*/ _jsxs(FreeBadge, {
                children: [
                    /*#__PURE__*/ _jsx(Gift, {
                        size: 16
                    }),
                    course_header_price_free()
                ]
            })
        });
    }
    if (!price) {
        return null;
    }
    const hasDiscount = price.originalAmount && price.originalAmount !== price.amount;
    return /*#__PURE__*/ _jsxs(PriceWrapper, {
        "data-testid": COURSE_DETAIL_TEST_IDS.PRICE_SECTION,
        children: [
            hasDiscount && /*#__PURE__*/ _jsx(OriginalPrice, {
                children: price.originalAmount
            }),
            /*#__PURE__*/ _jsx(PriceAmount, {
                children: price.displayPrice || price.amount
            }),
            hasDiscount && price.discount && /*#__PURE__*/ _jsxs(DiscountBadge, {
                children: [
                    price.discount,
                    "% OFF"
                ]
            })
        ]
    });
};
